import { render, staticRenderFns } from "./LmBiometricValidation.vue?vue&type=template&id=5a4ed314&scoped=true&"
import script from "./LmBiometricValidation.vue?vue&type=script&lang=js&"
export * from "./LmBiometricValidation.vue?vue&type=script&lang=js&"
import style0 from "./LmBiometricValidation.vue?vue&type=style&index=0&id=5a4ed314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ed314",
  null
  
)

export default component.exports